<div class="content pl-2">

  <div class="columns">
    <div class="column is-full">
      <div class="title">{{ 'claimSearch.title' | localize }}
        <app-year-selector class="subtitle is-6"/>
      </div>
      <p class="subtitle is-6">{{ 'claimSearch.subtitle' | localize }}</p>
    </div>
  </div>

  <div class="columns">
    <div class="column is-full">
      <app-claim-search-form
        (onInsuranceClaimReferenceSearch)="searchByInsuranceClaimReference($event)"
        (onInsuranceClaimReferenceCancelSearch)="cancelSearchByInsuranceClaimReference()"
      />
    </div>
  </div>

  @if (isLoading) {
    <div class="columns">
      <div class="column is-12">
        <mat-spinner></mat-spinner>
        <br/>
        {{ 'common.loading' | localize }}
      </div>
    </div>
  } @else {
    <div class="columns">
      <div class="column is-full">
        <app-claim-overview-statistics [claims]="(claimList)"/>
      </div>
    </div>

    @if (claimList.length > 0) {
      <div class="columns">
        <div class="column is-offset-10">
          <button class="button is-medium is-dark full-width" (click)="onExportClaims()" [disabled]="isDownloading">
            <span class="icon is-medium">
              <i class="fas fa-download"></i>
            </span>
            <span>{{ 'claimSearch.exportClaims' | localize }}</span>
          </button>
        </div>
      </div>
    }
    <div class="columns">
      <div class="column is-full">
        <app-claim-list [claims]="(claimList)" (onPageChange)="onPageChange($event)"/>
      </div>
    </div>
  }
</div>
